import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc Transaction Type - get All data
 */
export function getTransactionTypeAction() {

    let url = UrlConstants.transactionTypeUrl;

    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            dispatch({
                type: types.TRANSACTION_TYPE,
                transactionType: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}

/**
 * @desc TransactionType - add data
 */
export function addTransactionTypeAction(data) {

    let url = UrlConstants.transactionTypeUrl;

    return function (dispatch) {
        return APIUtil.postMethod(url, data, true).then(response => {
            dispatch({
                type: types.TRANSACTION_TYPE,
                transactionType: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}

/**
 * @desc transactionType - delete data
 */
export function deleteTransactionTypeAction(id) {
    let url = UrlConstants.deleteTransactionTypeUrl + '/' + id;

    return function (dispatch) {
        return APIUtil.deleteMethod(url, true).then(response => {
            dispatch({
                type: types.TRANSACTION_TYPE,
                transactionType: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}


/**
 * @desc transactionType - update data
 * 
 */
export function updateTransactionTypeAction(data, id) {
    let url = UrlConstants.updateTransactionTypeUrl + '/' + id;

    return function (dispatch) {
        return APIUtil.putMethod(url, data, true, "PATCH").then(response => {
            dispatch({
                type: types.TRANSACTION_TYPE,
                transactionType: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}